<template>
  <el-form-item :label="title">
    <el-autocomplete
      v-model="value"
      :placeholder="placeholder"
      :autofocus="focus"
      :style="{ width: width + 'px' }"
      :fetch-suggestions="handleQuery"
      @select="handleSelect"
      :clearable="true"
      @keyup.enter.native="search"
    ></el-autocomplete>
  </el-form-item>
</template>

<script>
// 专为QUOTING和OCOP列表页面输入固定建议词keywords的控件
import { parse, save } from '../providers/store-parser'
import { mapActions } from 'vuex'

export default {
  name: 'InputTextWithLocalSuggestions',
  props: {
    title: {
      type: String,
      required: true
    },
    // query: {
    //   type: Function,
    //   required: true
    // },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 145
    }
  },
  data () {
    return {
      tyreKeywords: []
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        save(this.setter, val)
      }
    }
  },
  methods: {
    // async handleQuery (queryString, cb) {
    //   if (queryString !== '') {
    //     const data = (await this.query(queryString))
    //     cb(data)
    //   }
    // },
    ...mapActions({
      search: 'search/search'
    }),
    handleQuery (queryString, cb) {
      const tyreKeywords = this.tyreKeywords
      var results = queryString ? tyreKeywords.filter(this._createFilter(queryString)) : tyreKeywords
      cb(results)
    },
    _createFilter (queryString) {
      return (tyreKeywords) => {
        return (tyreKeywords.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect () {
      // TODO
    }
  },
  mounted () {
    this.tyreKeywords = [
      { value: '2055516' },
      { value: '2156016' },
      { value: '2056515' },
      { value: '1956515' },
      { value: '2354517' },
      { value: '2454518' },
      { value: '2356017' },
      { value: '1756514' },
      { value: '2453520' },
      { value: '1956015' },
      { value: '2056016' },
      { value: '2354018' },
      { value: '2254517' },
      { value: '1855515' },
      { value: '2154517' },
      { value: '2155017' },
      { value: '2157016' },
      { value: '1756515' },
      { value: '2255517' },
      { value: '2355518' },
      { value: '2453519' },
      { value: '1856015' },
      { value: '2455519' },
      { value: '2156017' },
      { value: '1856514' },
      { value: '2254018' },
      { value: '2155517' },
      { value: '2454018' },
      { value: '2055017' },
      { value: '2156516' },
      { value: '2256517' },
      { value: '2255017' },
      { value: '2256016' },
      { value: '1856515' },
      { value: '2454019' },
      { value: '2256017' },
      { value: '2056516' }
    ]
  }
  // watch: {
  //   manual: function(val) {
  //     this.handler.call(this.provider, val)
  //   }
  // },
  // inject: ['provider']
}
</script>
